// Shared registration input validation (password strength + field lengths).
// Mirrors backend services/subscription/password_policy.py so client-side
// feedback matches server enforcement.

export const MAX_FIELD_LEN = 150;
export const MIN_PASSWORD_LEN = 8;

export const PASSWORD_RULES = [
  { key: 'length', label: `At least ${MIN_PASSWORD_LEN} characters`, test: (pw) => pw.length >= MIN_PASSWORD_LEN },
  { key: 'upper', label: 'One uppercase letter', test: (pw) => /[A-Z]/.test(pw) },
  { key: 'lower', label: 'One lowercase letter', test: (pw) => /[a-z]/.test(pw) },
  { key: 'number', label: 'One number', test: (pw) => /[0-9]/.test(pw) },
  { key: 'special', label: 'One special character', test: (pw) => /[^A-Za-z0-9]/.test(pw) },
];

// Returns an error string if the password is invalid, else null.
export function passwordError(pw) {
  if (!pw) return 'Password is required';
  if (pw.length > MAX_FIELD_LEN) return `Password must be at most ${MAX_FIELD_LEN} characters`;
  const failed = PASSWORD_RULES.find((r) => !r.test(pw));
  if (failed) {
    if (failed.key === 'length') return `Password must be at least ${MIN_PASSWORD_LEN} characters`;
    return `Password must contain ${failed.label.toLowerCase()}`;
  }
  return null;
}
